import { Entity } from "src/app/helpers/entity";

export class Savings  implements Entity {
    Id: number;
    ApplicationNo: number;
    DepositTypeId: number;
    CustomerId: number;
    CustomerName: string;
    Address: string;
    PanNo: string;
    Category: string;
    InterestRate: number;
    MaturityDate: Date;
    InterestPayementType: string;
    JointCustomers: string;
    DepositDate:Date;
    DepositAmount: number;
    SchemeId: number;
    NomineeName: string;
    NomineeRelationId: number;
    NomineeDOB: Date;
    RedemptionTypeId: number;
    AreaId: number;
    AgentName: string;
    AgentId: number;
    Instructions: string;
    BankAccNo: string;
    BankName: string;
    BankBranch: string;
    IFSCCode: string;
    PaymentTypeId: number;
    PaymentBankId: number;
    ChequeNo: string;
    IsJoint: string;
    Remarks: string;
    EmployeeId: number;
    EmployeeBranchId: number;
    CompanyId: number;
    SaasId: number;
    CreatedDate  : Date;
    ModifiedDate  : Date;
    IsActive: boolean;
    Flag: number;
    PreSavingsAmount: number;

    IsCustomerSearch : boolean ; //  it is using to select Customer Id & Name
    BranchId: Number;

    // for Passbook Report
    ReportName: string;
    ToDate : Date;
    CentreId: Number;
    IsOpening: boolean;
}
